//TODO: Hvis attachment er afvist + vis alt indhold derfra
//TODO: Hvis 401 - log ud?


import angular from 'angular';

import '../../../services/contract';
import '../../../services/user';
import '../../../directives/file-data-model';

import DateExtended from "serviceJs/date.service.ts";

import '../contracts-upload-files';

angular.module('folkeuni').component('contractsListMaterials', {
    templateUrl: '/shop-dist/templates/contracts-list-materials.html?c=' + window.cacheBurst,
    transclude: false,
    controller: function (Contract, User, $filter, $scope, $sce, $timeout, $element, $document, $window) {
        var $ctrl = this;
        $ctrl.contracts = [];
        $ctrl.showArchive = false;

        var today = new Date();
        var previousTermQuarter = today.getMonth() > 6 ? "1" : "2";
        var previousTermYear = String(today.getMonth() > 6 ? today.getYear() : today.getYear() - 1).substring(1, 3);

        $ctrl.previousTerms = Number(previousTermYear + previousTermQuarter);

        $ctrl.toggleArchive = function () {
            $ctrl.showArchive = !$ctrl.showArchive;
        }

        $ctrl.openUploadModal = function(contract) {
            $ctrl.selectedContractUpload = contract;
        }

        // error message
        $ctrl.messageError = function (item) {
            item.statusMessage = "Noget gik galt. Fejlkode: " + item.expenseMessageError + ".";
            item.messagerejected = true;
            item.expenseFormfade = true;


            $timeout(function () {
                return $timeout(function () {
                    item.notvisible = false;
                }, 3000);
            })
                .then(function () {
                    return $timeout(function () {
                        item.expenseFormfade = false;
                        item.expenceFormOpen = false;
                        // reset status message and form
                        item.statusMessage = false;
                        item.messagerejected = false;
                        resetExpense(item)
                        item.collapseDetapusgils = false;
                    }, 1000);
                });
        }

        $ctrl.$onInit = function () {
            User.getCurrent().then(function (userObj) {
                $ctrl.userCurrent = userObj;

                Contract.getApprovedAndRejectedContracts().then(function (contractObj) {
                    $ctrl.contracts = contractObj.map((entry) => {
                        entry.startDateFormatted = new DateExtended(entry.startDate).format('[D]/[M] [YYYY]');
                        return entry;
                    }).filter((contract) => {
                        return !contract.allCancelled;
                    });

                    // og payment method?? den er jo på hver linje
                    $ctrl.loading = false;
                }, function (errorReponse) {
                    $ctrl.loading = false;
                });

            }, function (errorResponse) {
                $ctrl.loading = false;
            });
        }
    }
});
